import { BookingPositionInput } from './BookingPositionService';

export const BookingPositionQueryKeys = {
	all: ['booking-position'] as const,
	scanCity: (companyHotelId: number) => [...BookingPositionQueryKeys.all, 'scan-city', companyHotelId] as const,
	state: (input: BookingPositionInput) => [...BookingPositionQueryKeys.all, 'state', input] as const,
};
